var map = {
	"./Mobil.svg": 29869,
	"./actions/alberta-add-to-outlook.svg": 71509,
	"./actions/alberta-add.svg": 43528,
	"./actions/alberta-box.svg": 89805,
	"./actions/alberta-cancel.svg": 7762,
	"./actions/alberta-close-button.svg": 2656,
	"./actions/alberta-cloud-upload.svg": 71096,
	"./actions/alberta-copy-url.svg": 18310,
	"./actions/alberta-copy.svg": 69248,
	"./actions/alberta-delete.svg": 89210,
	"./actions/alberta-download.svg": 41741,
	"./actions/alberta-edit.svg": 1974,
	"./actions/alberta-fab-remove-duplicate.svg": 74186,
	"./actions/alberta-fab-resend.svg": 58883,
	"./actions/alberta-grouped-list.svg": 64563,
	"./actions/alberta-minus-clear.svg": 6872,
	"./actions/alberta-minus.svg": 37248,
	"./actions/alberta-numbered-list.svg": 81504,
	"./actions/alberta-patient-download.svg": 96087,
	"./actions/alberta-play.svg": 63872,
	"./actions/alberta-plus-clear.svg": 58861,
	"./actions/alberta-plus.svg": 2747,
	"./actions/alberta-preview.svg": 75564,
	"./actions/alberta-reorder.svg": 53273,
	"./actions/alberta-resend.svg": 50226,
	"./actions/alberta-reset.svg": 39216,
	"./actions/alberta-save-as-draft.svg": 41509,
	"./actions/alberta-save.svg": 81094,
	"./actions/alberta-scan.svg": 99283,
	"./actions/alberta-signature.svg": 18779,
	"./actions/alberta-stop.svg": 41363,
	"./actions/alberta-sync.svg": 41610,
	"./actions/alberta-trash.svg": 66566,
	"./actions/alberta-upload.svg": 12847,
	"./activities/alberta-activities-sort-current.svg": 56614,
	"./activities/alberta-activities-sort-past.svg": 73420,
	"./activities/alberta-activities.svg": 62888,
	"./activities/alberta-activity-date.svg": 50244,
	"./activities/alberta-activity-endtime.svg": 71410,
	"./activities/alberta-activity-starttime.svg": 7494,
	"./activities/alberta-recurring-activity.svg": 9037,
	"./assets/alberta-additional-description.svg": 31506,
	"./assets/alberta-address.svg": 22361,
	"./assets/alberta-attachment.svg": 39732,
	"./assets/alberta-available.svg": 60826,
	"./assets/alberta-brush-outline.svg": 22033,
	"./assets/alberta-bug.svg": 65674,
	"./assets/alberta-call.svg": 6091,
	"./assets/alberta-camera.svg": 37215,
	"./assets/alberta-change-of-supplier.svg": 25446,
	"./assets/alberta-clipboard.svg": 77695,
	"./assets/alberta-clock.svg": 19611,
	"./assets/alberta-comment.svg": 72603,
	"./assets/alberta-content.svg": 42698,
	"./assets/alberta-customer-number.svg": 60564,
	"./assets/alberta-death.svg": 4989,
	"./assets/alberta-delayed.svg": 94201,
	"./assets/alberta-description.svg": 59203,
	"./assets/alberta-disk.svg": 74192,
	"./assets/alberta-document-info.svg": 67900,
	"./assets/alberta-document.svg": 59940,
	"./assets/alberta-dot-no.svg": 13847,
	"./assets/alberta-dot-unknown.svg": 74306,
	"./assets/alberta-dot-yes.svg": 67293,
	"./assets/alberta-dot.svg": 47727,
	"./assets/alberta-encrypted.svg": 63677,
	"./assets/alberta-erp.svg": 19360,
	"./assets/alberta-eye-off.svg": 56653,
	"./assets/alberta-eye.svg": 5554,
	"./assets/alberta-foto.svg": 34484,
	"./assets/alberta-gender.svg": 95083,
	"./assets/alberta-hammer-outline.svg": 66023,
	"./assets/alberta-hammer.svg": 87210,
	"./assets/alberta-history.svg": 52903,
	"./assets/alberta-icon.svg": 11377,
	"./assets/alberta-info-outline.svg": 58830,
	"./assets/alberta-info.svg": 23989,
	"./assets/alberta-invalid-section.svg": 53026,
	"./assets/alberta-iv-patient.svg": 51229,
	"./assets/alberta-key.svg": 37244,
	"./assets/alberta-label-info.svg": 32288,
	"./assets/alberta-label-success.svg": 96542,
	"./assets/alberta-last-login.svg": 38297,
	"./assets/alberta-lens.svg": 35204,
	"./assets/alberta-lock.svg": 52159,
	"./assets/alberta-match.svg": 94734,
	"./assets/alberta-more.svg": 76240,
	"./assets/alberta-new.svg": 87455,
	"./assets/alberta-next-visit-delete.svg": 24506,
	"./assets/alberta-next-visit-field.svg": 22899,
	"./assets/alberta-nexttermin.svg": 85611,
	"./assets/alberta-not-available.svg": 96829,
	"./assets/alberta-note.svg": 98546,
	"./assets/alberta-notification-badge.svg": 57546,
	"./assets/alberta-operating-hours.svg": 80935,
	"./assets/alberta-outpatient.svg": 89359,
	"./assets/alberta-patient-inactive.svg": 15350,
	"./assets/alberta-person-chip.svg": 74854,
	"./assets/alberta-person.svg": 73660,
	"./assets/alberta-photo-gallery.svg": 42170,
	"./assets/alberta-picture.svg": 29169,
	"./assets/alberta-place.svg": 62895,
	"./assets/alberta-question.svg": 99232,
	"./assets/alberta-referrer.svg": 97910,
	"./assets/alberta-region.svg": 19411,
	"./assets/alberta-registration.svg": 70764,
	"./assets/alberta-report.svg": 33220,
	"./assets/alberta-reset-outline.svg": 88599,
	"./assets/alberta-return-arrow.svg": 34112,
	"./assets/alberta-return-delivery.svg": 344,
	"./assets/alberta-ruler-outline.svg": 26180,
	"./assets/alberta-ruler.svg": 47109,
	"./assets/alberta-search-filled.svg": 95418,
	"./assets/alberta-sos.svg": 46929,
	"./assets/alberta-star.svg": 45949,
	"./assets/alberta-status-star.svg": 42963,
	"./assets/alberta-status.svg": 40319,
	"./assets/alberta-subunit.svg": 37720,
	"./assets/alberta-summary.svg": 41811,
	"./assets/alberta-team.svg": 93321,
	"./assets/alberta-text.svg": 89380,
	"./assets/alberta-unlock.svg": 69013,
	"./assets/alberta-warning.svg": 84692,
	"./assets/alberta-website-filled.svg": 43983,
	"./assets/alberta-website-light.svg": 21114,
	"./assets/alberta-website.svg": 37562,
	"./assets/alberta-zoom-in-outline.svg": 62994,
	"./assets/alberta-zoom-out-outline.svg": 49651,
	"./assets/itl-label-info.svg": 66182,
	"./chat/alberta-chat-assign.svg": 12024,
	"./chat/alberta-chat-channel-list-offline.svg": 36549,
	"./chat/alberta-chat-close.svg": 26869,
	"./chat/alberta-chat-selected-badge.svg": 64062,
	"./communication/alberta-address-book.svg": 52449,
	"./communication/alberta-fax.svg": 56582,
	"./communication/alberta-mail.svg": 39015,
	"./communication/alberta-message.svg": 80930,
	"./communication/alberta-mobile.svg": 44217,
	"./communication/alberta-notification.svg": 18126,
	"./communication/alberta-phone.svg": 94809,
	"./communication/alberta-support.svg": 86258,
	"./fab-icons/alberta-fab-additional-order.svg": 84252,
	"./fab-icons/alberta-fab-box.svg": 72617,
	"./fab-icons/alberta-fab-change-document.svg": 89325,
	"./fab-icons/alberta-fab-checkbox-off.svg": 46595,
	"./fab-icons/alberta-fab-checkbox-on.svg": 10724,
	"./fab-icons/alberta-fab-contact-data.svg": 18207,
	"./fab-icons/alberta-fab-copy.svg": 53127,
	"./fab-icons/alberta-fab-delete.svg": 27130,
	"./fab-icons/alberta-fab-document.svg": 2004,
	"./fab-icons/alberta-fab-download.svg": 890,
	"./fab-icons/alberta-fab-edit.svg": 15298,
	"./fab-icons/alberta-fab-fax.svg": 71783,
	"./fab-icons/alberta-fab-next-visit-delete.svg": 22874,
	"./fab-icons/alberta-fab-next-visit.svg": 16938,
	"./fab-icons/alberta-fab-order.svg": 75227,
	"./fab-icons/alberta-fab-patient-active.svg": 26041,
	"./fab-icons/alberta-fab-patient-inactive.svg": 28505,
	"./fab-icons/alberta-fab-pdf.svg": 15769,
	"./fab-icons/alberta-fab-print.svg": 9979,
	"./fab-icons/alberta-fab-return-delivery.svg": 43780,
	"./fab-icons/alberta-fab-send-email.svg": 95390,
	"./fab-icons/alberta-fab-send-full.svg": 88366,
	"./fab-icons/alberta-fab-send.svg": 51937,
	"./fab-icons/alberta-fab-service-order.svg": 99145,
	"./fab-icons/alberta-fab-share-native.svg": 56804,
	"./fab-icons/alberta-fab-share.svg": 47092,
	"./fab-icons/alberta-fab-status.svg": 66508,
	"./fab-icons/alberta-fab-stock-check.svg": 50579,
	"./fab-icons/alberta-fab-subunit.svg": 11355,
	"./inputs/alberta-checkbox-checked.svg": 15717,
	"./inputs/alberta-checkbox-empty.svg": 41565,
	"./institutions/alberta-crm.svg": 77895,
	"./institutions/alberta-doctor.svg": 30665,
	"./institutions/alberta-hospital.svg": 42699,
	"./institutions/alberta-nursinghome.svg": 8710,
	"./institutions/alberta-nursingservice.svg": 49705,
	"./institutions/alberta-payer.svg": 45430,
	"./institutions/alberta-pharmacy.svg": 88925,
	"./integratedcare/alberta-ic-attachments.svg": 4798,
	"./integratedcare/alberta-ic-edit.svg": 50479,
	"./integratedcare/alberta-ic-order.svg": 42490,
	"./integratedcare/alberta-ic-other.svg": 56059,
	"./integratedcare/alberta-ic-reminder.svg": 10967,
	"./integratedcare/alberta-ic-send.svg": 60198,
	"./medical/alberta-body-size.svg": 7127,
	"./medical/alberta-diagnosis.svg": 64476,
	"./medical/alberta-dialysis.svg": 88209,
	"./medical/alberta-human-body.svg": 47495,
	"./medical/alberta-weight.svg": 85690,
	"./medical/alberta-wound-bandage-change.svg": 58318,
	"./medical/alberta-wound-load.svg": 63120,
	"./medical/alberta-wound-location.svg": 32466,
	"./medical/alberta-wound-permanent.svg": 80840,
	"./menu/alberta-burger-close.svg": 98096,
	"./menu/alberta-burger-menu-dashboard.svg": 81618,
	"./menu/alberta-burger-menu.svg": 60715,
	"./menu/alberta-calendar-check.svg": 17993,
	"./menu/alberta-calendar.svg": 47816,
	"./menu/alberta-chat.svg": 81500,
	"./menu/alberta-dashboard.svg": 86506,
	"./menu/alberta-help.svg": 38322,
	"./menu/alberta-lists.svg": 40388,
	"./menu/alberta-logout.svg": 89438,
	"./menu/alberta-prescription-mgn.svg": 48568,
	"./menu/alberta-setting.svg": 8358,
	"./menu/alberta-swodoc.svg": 52884,
	"./navigation/alberta-arrow-down.svg": 22578,
	"./navigation/alberta-arrow-dropup.svg": 59083,
	"./navigation/alberta-arrow-left.svg": 22855,
	"./navigation/alberta-arrow-right.svg": 38824,
	"./navigation/alberta-fab-icon.svg": 95801,
	"./order/alberta-accounting-month.svg": 67034,
	"./order/alberta-across-therapy-order.svg": 67303,
	"./order/alberta-annotation.svg": 31583,
	"./order/alberta-contract.svg": 45925,
	"./order/alberta-direct-order-full.svg": 51413,
	"./order/alberta-direct-order.svg": 53501,
	"./order/alberta-euro.svg": 83179,
	"./order/alberta-interval.svg": 99302,
	"./order/alberta-lorry-return-delivery-in-details.svg": 357,
	"./order/alberta-lorry-return-delivery.svg": 90654,
	"./order/alberta-lorry.svg": 45687,
	"./order/alberta-not-automatic-delivery.svg": 67826,
	"./order/alberta-pharmacy-only.svg": 42280,
	"./order/alberta-prescription-status.svg": 21531,
	"./order/alberta-private-sale-order.svg": 79236,
	"./order/alberta-product-group-checkmark.svg": 50218,
	"./order/alberta-seriesorder.svg": 75974,
	"./order/alberta-service-order.svg": 69597,
	"./order/alberta-shoppingcart-checkmark.svg": 27222,
	"./order/alberta-shoppingcart-euro.svg": 35320,
	"./order/alberta-shoppingcart-full-abo.svg": 21690,
	"./order/alberta-shoppingcart-full.svg": 27996,
	"./order/alberta-shoppingcart-small-icon-button.svg": 96962,
	"./order/alberta-shoppingcart-square-full.svg": 61847,
	"./order/alberta-shoppingcart-square.svg": 27103,
	"./order/alberta-shoppingcart.svg": 61504,
	"./patient/additional-address.svg": 93681,
	"./patient/alberta-additional-attributes.svg": 64205,
	"./patient/alberta-ambulant.svg": 29231,
	"./patient/alberta-birthday.svg": 66028,
	"./patient/alberta-contact-data.svg": 78200,
	"./patient/alberta-customer-id.svg": 48519,
	"./patient/alberta-fieldnurse.svg": 2697,
	"./patient/alberta-filter-active.svg": 93713,
	"./patient/alberta-filter-multiple.svg": 37793,
	"./patient/alberta-filter-nursinghome.svg": 33440,
	"./patient/alberta-filter.svg": 72338,
	"./patient/alberta-internal-data.svg": 5851,
	"./patient/alberta-person-cirle.svg": 59237,
	"./patient/alberta-pwr.svg": 38678,
	"./patient/alberta-search-clear.svg": 59666,
	"./patient/alberta-search.svg": 65979,
	"./patient/alberta-sort-1-to-9.svg": 45378,
	"./patient/alberta-sort-9-to-1.svg": 59417,
	"./patient/alberta-sort-a-to-z.svg": 90284,
	"./patient/alberta-sort-next-visit-current.svg": 99220,
	"./patient/alberta-sort-next-visit-future.svg": 65402,
	"./patient/alberta-sort-timestamp-new.svg": 9850,
	"./patient/alberta-sort-timestamp-old.svg": 95699,
	"./patient/alberta-sort-z-to-a.svg": 49297,
	"./patient/alberta-visit-days.svg": 48507,
	"./patient/alberta-visit-interval.svg": 83198,
	"./product/alberta-article.svg": 2203,
	"./product/alberta-contract-article-group.svg": 22442,
	"./product/alberta-maxamount.svg": 42660,
	"./product/alberta-packaging.svg": 80005,
	"./product/alberta-prescription.svg": 87407,
	"./product/alberta-produce.svg": 27709,
	"./product/alberta-productgroup.svg": 75777,
	"./product/alberta-productlist.svg": 39351,
	"./product/alberta-series-article.svg": 43957,
	"./product/alberta-service.svg": 65067,
	"./product/alberta-size.svg": 88125,
	"./product/alberta-stdcareproposal.svg": 95618,
	"./product/alberta-template.svg": 8027,
	"./product/alberta-vendor.svg": 78699,
	"./table/alberta-article-data.svg": 23339,
	"./table/alberta-circle.svg": 30272,
	"./table/alberta-false-cross-circle-icon.svg": 17765,
	"./table/alberta-individual-data.svg": 85010,
	"./table/alberta-insurance-price.svg": 99853,
	"./table/alberta-price.svg": 62651,
	"./table/alberta-true-check-circle-icon.svg": 30773,
	"./table/albertra-packaging-unit.svg": 68662,
	"./therapies/alberta-antibody-therapy.svg": 76503,
	"./therapies/alberta-asept.svg": 85460,
	"./therapies/alberta-breath-therapy.svg": 23397,
	"./therapies/alberta-cross-therapy.svg": 74840,
	"./therapies/alberta-derive-incontinence.svg": 98517,
	"./therapies/alberta-diabetes.svg": 52835,
	"./therapies/alberta-diagnostics.svg": 62141,
	"./therapies/alberta-drug-distribution.svg": 46906,
	"./therapies/alberta-electrostimulation.svg": 93173,
	"./therapies/alberta-enteral-nutrition.svg": 87857,
	"./therapies/alberta-enterostomy.svg": 4765,
	"./therapies/alberta-general.svg": 86233,
	"./therapies/alberta-high-flow.svg": 38356,
	"./therapies/alberta-humidification.svg": 65560,
	"./therapies/alberta-imbibe-incontinence.svg": 12481,
	"./therapies/alberta-immunotherapy.svg": 28898,
	"./therapies/alberta-incontinence.svg": 92171,
	"./therapies/alberta-medical-engineering.svg": 94867,
	"./therapies/alberta-medical-technology.svg": 19405,
	"./therapies/alberta-monitoring.svg": 85953,
	"./therapies/alberta-orthopedic-technology.svg": 89665,
	"./therapies/alberta-pain-therapy.svg": 88381,
	"./therapies/alberta-parenteral-feeding.svg": 747,
	"./therapies/alberta-rehab-aids.svg": 69173,
	"./therapies/alberta-rehydration.svg": 9121,
	"./therapies/alberta-seat-shell-construction.svg": 38294,
	"./therapies/alberta-services.svg": 19089,
	"./therapies/alberta-sip-feeding.svg": 52912,
	"./therapies/alberta-storage-aids.svg": 69485,
	"./therapies/alberta-subcutane-infusion.svg": 49160,
	"./therapies/alberta-therapy-miscellaneous.svg": 19738,
	"./therapies/alberta-therapy.svg": 45307,
	"./therapies/alberta-tooth-splint.svg": 93701,
	"./therapies/alberta-tracheostomy.svg": 32899,
	"./therapies/alberta-wound.svg": 43410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75293;